export default function stackid(stackType = {}, action) {
    if (action.type === 'stackType') {
      return action.stackType;
    } else {
        return stackType;
    }
}
